import React, { Component } from 'react';



export default class UserAlreadyLoggedInComp extends Component {


    constructor(props) {
        super(props);
        
    }
    
    render() {        
      
            return (<div style={{padding:"15px"}}>
                <div>
                    A user <span style={{ fontWeight: 'bold' }}>{this.props.UserName}</span> is already logged in.<br />
                   If you are not <span style={{ fontWeight: 'bold' }}>{this.props.UserName}</span> or you want to login as another user then click on the link below.<br />
                                        </div>
                                        <a id='lnkKillCurrent' className='basicLnkBtn' 
                                            onClick={() => this.onKillCurrentClick()}>Continue with Login</a>
                                       
                                    </div>
                               
              );

    }
    onKillCurrentClick() {
        window.location = window.baseUrl + 'Login/KillCurrentUserSession';
    }
}
 